import { render, staticRenderFns } from "./rightTop2.vue?vue&type=template&id=561f40e6&scoped=true"
import script from "./rightTop2.vue?vue&type=script&lang=js"
export * from "./rightTop2.vue?vue&type=script&lang=js"
import style0 from "./rightTop2.vue?vue&type=style&index=0&id=561f40e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f40e6",
  null
  
)

export default component.exports